module.exports = __webpack_public_path__ + "img/Newbie_Bow_02_Warrior.93e9b893.png";